namespace $ {
	/** Durable specs and journals; new runs are queued for an independent Playwright worker. */
		export class $shm_hitalama_components_scenario_service extends $mol_object {
		private active = new Set<string>()
		private workers = new Map<string, $shm_hitalama_components_tests_service>()
		worker( name: string ) {
			if( !this.workers.has( name ) ) this.workers.set( name, this.$.$shm_hitalama_components_tests_service.make({ definition: ()=> this.definition( name ) }) )
			return this.workers.get( name )!
		}
		ui() { return null as any as $shm_hitalama_components_ui }
		async source_hash( name: string ) {
			const definition = await $mol_wire_async( this ).definition( name )
			const loader = new this.$.$shm_hitalama_map_component
			try {
				const graph = await $mol_wire_async( loader ).graph( definition )
				const bytes = new TextEncoder().encode( JSON.stringify( graph.map( item => item.source ) ) )
				const hash = await crypto.subtle.digest( 'SHA-256', bytes )
				return [...new Uint8Array( hash )].map( byte => byte.toString( 16 ).padStart( 2, '0' ) ).join( '' )
			} finally { loader.destructor() }
		}
		definition( name: string ) {
			const item = this.$.$shm_hitalama_components_catalog.current()?.definition( name )
			if( !item ) throw new Error( 'Модуль не найден.' )
			this.$.$shm_hitalama_map_component_ready.read( item )
			return item
		}
		id( id: string ) {
			if( typeof id !== 'string' || !/^[A-Za-z0-9-]{1,80}$/.test( id ) ) throw new Error( 'ID сценария: 1–80 латинских букв, цифр или дефисов.' )
			return id
		}
		scenario( name: string, id: string ) {
			const scenario = this.definition( name ).Test_scenarios()?.key( this.id( id ) )?.remote()
			if( !scenario ) throw new Error( 'Сценарий не найден.' )
			this.$.$shm_hitalama_map_component_ready.read( scenario )
			return scenario
		}
		@ $mol_action
		save( name: string, id: string, text: string, expected: string ) {
			this.id( id ); $shm_hitalama_components_scenario.validate( text )
			const definition = this.definition( name )
			if( !definition.can_change() ) throw new Error( 'Нет прав на сохранение сценария.' )
			const atom = definition.Test_scenarios( null )!.key( id, null )!
			const previous = atom.remote()
			if( previous ) this.$.$shm_hitalama_map_component_ready.read( previous )
			const before = previous?.Spec()?.val() ?? ''
			if( before !== expected && before !== text ) throw new Error( 'Сценарий изменился. Перечитайте его перед сохранением.' )
			if( before === text ) return { id, saved: true }
			const scenario = previous ?? $mol_wire_sync( this ).allocate( definition )
			scenario.Spec( null )!.val( text )
			atom.remote( scenario )
			return { id, saved: true }
		}
		allocate( definition: $shm_hitalama_map_widget_entity_custom ) { return definition.land().area_make().Data( $shm_hitalama_components_scenario ) }
		allocate_run( scenario: $shm_hitalama_components_scenario ) { return scenario.land().area_make().Data( $shm_hitalama_components_scenario_run ) }
		run( name: string, id: string, run_id: string ) {
			const run = this.scenario( name, id ).Runs()?.key( this.id( run_id ) )?.remote()
			if( !run ) throw new Error( 'Прогон не найден.' )
			this.$.$shm_hitalama_map_component_ready.read( run )
			return run
		}
		async start( params: Record<string,any> ) {
			const scenario = await $mol_wire_async( this ).scenario( params.name, params.id )
			if( !scenario.can_change() ) throw new Error( 'Нет прав на запись результата сценария.' )
			const text = await $mol_wire_async( scenario.Spec()! ).val() ?? ''
			const spec = $shm_hitalama_components_scenario.validate( text )
			if( spec.runner === 'playwright' ) {
				const run_id = await $mol_wire_async( this.worker( params.name ) ).enqueue( params, params.id )
				return { run_id, status: 'queued', runner: 'playwright', poll: 'application_test_result', browser_must_stay_open: false }
			}
			if( spec.mode === 'default' && params.allow_real !== true ) throw new Error( 'Сценарий меняет реальное приложение. Для запуска передайте allow_real: true.' )
			const run_id = crypto.randomUUID()
			const source_hash = await this.source_hash( params.name )
			const run = await $mol_wire_async( this ).allocate_run( scenario )
			// An async job is not a wire subscriber. Keep its land rooted across
			// awaits so GC cannot replace its model before the journal is published.
			const root = new $mol_wire_atom( 'application_test_run', ()=> run.Data()?.val() )
			root.fresh()
			const data: any = { run_id, name: params.name, id: params.id, title: spec.title, mode: spec.mode, spec: text, source_hash, client_id: this.ui().app().mcp_client().client_id(), started: new Date().toISOString(), status: 'running', steps: [] }
			try {
				await $mol_wire_async( run.Data( null )! ).val( JSON.stringify( data ) )
				await $mol_wire_async( scenario.Runs( null )!.key( run_id, null )! ).remote( run )
			} catch( error ) { root.destructor(); throw error }
			this.active.add( run_id )
			// A separate bounded job is owned by this service until its finally block.
			void this.ui().exclusive( async()=> {
				const started = performance.now(), deadline = Date.now() + 60000
				try {
					await this.ui().open( params.name, spec.mode )
					for( let index = 0; index < spec.steps.length; ++index ) {
						if( Date.now() > deadline ) throw new Error( 'Сценарий превысил 60 секунд.' )
						const step = spec.steps[index], begin = performance.now()
						try {
							if( step.action === 'screenshot' ) {
								throw new Error( 'Медиа не сохраняются. Для временного просмотра используйте application_screenshot или Playwright.' )
							} else {
								const state = await this.ui().act( params.name, { ...step, label: step.name, timeout_ms: Math.min( 5000, deadline - Date.now() ) } )
								if( state.runtime_errors.length || state.errors.some( item => item.type !== 'Promise' && item.type !== '$mol_promise_blocker' ) ) throw new Error( 'Ошибка приложения: ' + JSON.stringify([ ...state.runtime_errors, ...state.errors ]) )
							}
							data.steps.push({ index, action: step.action, label: step.label ?? '', status: 'passed', ms: Math.round( performance.now() - begin ) })
						} catch( error ) {
							data.steps.push({ index, action: step.action, label: step.label ?? '', status: 'failed', error: String( ( error as Error ).message ), ms: Math.round( performance.now() - begin ) })
							throw error
						}
						await $mol_wire_async( run.Data( null )! ).val( JSON.stringify( data ) )
					}
					data.status = 'passed'
				} catch( error ) { data.status = 'failed'; data.error = String( ( error as Error ).message ) }
				finally {
					data.ms = Math.round( performance.now() - started ); data.finished = new Date().toISOString()
					await $mol_wire_async( run.Data( null )! ).val( JSON.stringify( data ) )
				}
			}).catch( async error => {
				data.status = 'failed'; data.error = String( error ); data.finished = new Date().toISOString()
				await $mol_wire_async( run.Data( null )! ).val( JSON.stringify( data ) )
			}).catch( $mol_fail_log ).finally( ()=> { this.active.delete( run_id ); root.destructor() } )
			return { run_id, status: 'running', poll: 'application_test_result', browser_must_stay_open: true }
		}
		async image( params: Record<string,any> ) {
			const run = await $mol_wire_async( this ).run( params.name, params.id, params.run_id )
			const file = await $mol_wire_async( ()=> run.Shots()?.key( String( params.shot ) )?.remote() )()
			if( !file ) throw new Error( 'Снимок шага не найден.' )
			const buffer = await $mol_wire_async( file ).buffer()
			if( buffer.byteLength > 2100000 ) throw new Error( 'Снимок слишком большой.' )
			let binary = ''; for( const byte of buffer ) binary += String.fromCharCode( byte )
			return { image: { mimeType: 'image/png', data: btoa( binary ) }, approximate: JSON.parse( run.Data()?.val() || '{}' ).runner !== 'playwright', run_id: params.run_id, shot: params.shot }
		}
		async handle( method: string, params: Record<string,any> ): Promise<any> {
			if( method === 'application_test_save' ) return $mol_wire_async( this ).save( params.name, params.id, params.text, params.expected )
			if( method === 'application_test_run' ) return this.start( params )
			if( method === 'application_test_image' ) return this.image( params )
			if( method === 'application_tests' ) {
				const definition = await $mol_wire_async( this ).definition( params.name )
				return { ids: await $mol_wire_async( ()=> definition.Test_scenarios()?.keys() ?? [] )() }
			}
			const scenario = await $mol_wire_async( this ).scenario( params.name, params.id )
			if( method === 'application_test_get' ) return { id: params.id, text: await $mol_wire_async( scenario.Spec()! ).val(), runs: await $mol_wire_async( ()=> scenario.Runs()?.keys() ?? [] )() }
			if( method === 'application_test_result' ) {
				const run = await $mol_wire_async( this ).run( params.name, params.id, params.run_id )
				const atom = run.Data()
				if( !atom ) throw new Error( 'У прогона отсутствует Data: ' + run.link().str )
				const data = JSON.parse( await $mol_wire_async( atom ).val() ?? '{}' )
				if( data.runner === 'playwright' && data.status === 'running' && Date.now() - Date.parse( data.started ) > 95000 ) return { ...data, stored_status: data.status, status: 'interrupted', error: 'Исполнитель не завершил прогон. Старые действия автоматически не повторяются.', shots: await $mol_wire_async( ()=> run.Shots()?.keys() ?? [] )() }
				if( data.runner !== 'playwright' && data.status === 'running' && ( data.client_id === this.ui().app().mcp_client().client_id() && !this.active.has( data.run_id ) || Date.now() - Date.parse( data.started ) > 90000 ) ) {
					data.stored_status = data.status; data.status = 'interrupted'; data.error = 'Клиент был перезагружен или прогон перестал отвечать. Создайте новый прогон явно; старые действия автоматически не повторяются.'
				}
				return { ...data, shots: await $mol_wire_async( ()=> run.Shots()?.keys() ?? [] )() }
			}
			throw new Error( 'Неизвестная команда сценариев.' )
		}
	}
}
